<template>
  <div class="popup-main">
    <el-dialog
      title="设为负责人"
      width="500px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :data.sync="selfDetail"
          :rules="rules"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {
        parent_id: '',
        parent_name: '无',
        id: '',
        name: ''
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '部门名称',
          field: 'parent_name',
          disabled: true
        },
        {
          type: 'text',
          title: '负责人',
          field: 'name',
          disabled: true
        },
        {
          type: 'text',
          title: '负责人职称',
          field: 'leader_name',
          required: true
        }
      ],
      rules: {
        leader_name: [{ required: true, message: '请输入负责人职称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfDetail = this.$util.deepCopy(this.detail)
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/bumen/changeFuZeRen',
            data: {
              account_id: this.selfDetail.account_id,
              bu_men_id: this.selfDetail.parent_id,
              is_leader: true,
              leader_name: this.selfDetail.leader_name
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('操作成功')
              this.$emit('success')
              this.popupCancel()
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
